var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"name":"contenedorestadisticas"}},[_c('h2',[_vm._v("en Estadisticas")]),_c('ComponenteSelectorFechas'),_c('ComponenteTotal'),_c('ComponenteIncidentesProgramas')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }